import axios from 'axios'
import { getToken } from '../user/tokens'
import { userLanguageSelector } from '~/tools/localization'
import { getSeriesIdFromPayload, addWatchHistoryToPayload, formatHistory, addEpisodeNumbersToPayload} from './helpers';
import Cookies from 'js-cookie';

export function fetchPage(route, langCode, ip, userId) {

  if(userId == null){
    userId = Cookies.get('vl-user');
  } 

  var promise = getToken().then( token => {
    var 
      s = window.settings,
      content,
      layout,
      contentUrl = s.apiBaseUrl + s.pageEndpoint,
      languageCode = userLanguageSelector(s, langCode)

    var contentApiHeaders = {
      Authorization: token,
      'x-api-key': s.baseAPIKey,
    }

    if (ip) 
      contentApiHeaders['X-Forwarded-For'] = ip

    return axios
      .get(contentUrl, {
        params: {
          path: route,
          site: s.internalName,
          includeContent: true,
          ...(languageCode ? { languageCode } : {})
        },
        headers: contentApiHeaders
      })
      .then( r => {
        content = r.data

        addEpisodeNumbersToPayload(content);

        var layoutUrl = `${s.layoutUrlBase}${s.siteId}/web/${content.id}.json?timestamp=${ (new Date()).getTime() }`
        var layoutApiHeaders = ip ? { 'X-Forwarded-For': ip } : {}
        return axios.get(layoutUrl, { headers: layoutApiHeaders } ).then( s => layout = s.data )
      })
      // Get watch history for videos if we are on a showpage. This is a hack as the information would ideally be already in the pages API
      .then( () => {

        const seriesId = getSeriesIdFromPayload(content);

        if(seriesId && userId) {
          return axios.get(`${s.apiBaseUrl}/content/video/history/user/${userId}`, {
            headers: contentApiHeaders, 
            params: {
              seriesId: seriesId,
              site: s.internalName,
            } 
          }).then( history => {
            if(Array.isArray(history.data)){
              addWatchHistoryToPayload(formatHistory(history.data), content); 
            }
          });
        } else {
          return Promise.resolve()
        }

      })
      .then( _ => {
        return {
          title: content.title,
          categoryMap: content.categoryMap,
          metadataMap: content.metadataMap,
          id: content.id,
          modules: content.modules,
          layouts: layout.moduleList,
          styles: layout.pageStyle,
          route: route,
          ip: ip,
          lang: languageCode
        }
      })
  })

  return { type: 'FETCH_PAGE', payload: promise }
}